import PropTypes from "prop-types";
import React, {
	Component
} from "react";
import {
	View,
	Dimensions,
	TouchableOpacity,
	SafeAreaView,
	Platform,
	TextInput,
	Text
} from "react-native";

import InputLabel from "./Layout/InputLabel";
import InputContainer from "./Layout/InputContainer";
import ErrorMessage from "./Layout/ErrorMessage";
import StyledButton from "ae-base/Base/StyledButton";
import StyledText from "ae-base/Base/StyledText";
import ModalOverlay from "ae-base/Base/ModalOverlay";
import MainScroll from "ae-base/Base/MainScroll";
import BackButton from "ae-base/Base/BackButton";
import Heading from "ae-base/Base/Heading";
import ListItem from "ae-base/List/ListItem";
import StyledIcon from "ae-base/Base/StyledIcon";
import SearchBox from "./SearchBox";
import {
	debounce
} from "lodash";

import Style from "ae-style";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'

const styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		searchText: {
			marginVertical: Style.layout.marginLarge
		},
		searchBox: {
			marginBottom: Style.layout.marginLarge
		},
		container: {
			margin: Style.layout.marginBordered,
			padding: Style.layout.paddingSmall,
			backgroundColor: Style.look.background
		},
		back: {
			marginLeft: Style.layout.marginBordered,
			marginTop: Style.layout.marginBordered
		},
		listItem: {
			justifyContent: "space-between"
		},
		textContainer: {
			flexDirection: "row",
			flexShrink: 1,
			flexWrap: "wrap"
		},
		loadContainer: {
			alignItems: "center",
			justifyContent: "center",
			margin: Style.layout.paddingSlim
		},
		headingContainer: {
			marginBottom: Style.layout.marginContentSmall
		},
		header: {
			flexDirection: "row",
			justifyContent: "space-between",
		},
		input: {
			flexDirection: "row",
			alignItems: "center",
		},
		optionInput: {
			borderWidth: 1,
			borderColor: "gray",
			borderRadius: 5,
			padding: 10,
			marginBottom: 10,
			width: 200,
			marginLeft: 10
		},
		form: {
			flexDirection: "row",
			justifyContent: Platform.OS === "web" ? "flex-start" : "center",
			alignItems: Platform.OS === "web" ? "baseline" : "center",
			padding: 10
		},
		label: {
			fontWeight: "bold",
			minWidth: 100
		},
		actions: {
			flexDirection: "row",
			justifyContent: "flex-end",
			marginTop: 0,
			marginBottom: Style.layout.marginSmall,
		},
		cancel: {
			marginLeft: Style.layout.marginSmall
		},
		icon: {
			marginHorizontal: Style.layout.paddingSlim
		},
		safeContainer: {
			backgroundColor: "black",
			flex: 1
		},
		noResultContainer: {
			flex: 1,
			alignItems: "center",
			justifyContent: "center",
			padding: Style.layout.paddingSlim
		},
		scroll: {
			marginBottom: 15
		},
		primaryColor: {
			backgroundColor: Style.colors.primary
		}
	},
	512: {
		back: {
			marginLeft: Style.layout.marginContent,
			marginTop: Style.layout.marginContentVertical
		},
		container: {
			margin: Style.layout.marginContent,
			padding: Style.layout.paddingLarge,
			backgroundColor: Style.look.background
		}
	}
});

export default class CustomOption extends Component {
	constructor(props){
		super(props);

		this.state = {
			searching: false,
			options: [],
			selected: null,
			shouldLoadMore: false,
			loaded: false,
			searchText: "",
			isAdd: false,
			addData: {},
			keys: [],
			values: [],
			isEdit: false,
			editData: {},
			newData: {}
		};
	}

	handleModelUpdate = (list) => {
		this.setState({
			options: list
		});
		if(list.length > 0){
			this.setState({
				keys: list[0] ? Object.keys(list[0].data) : [],
			});
		}
	}

	handleShouldLoadMore = (shouldLoad) => {
		if(!shouldLoad && this.state.shouldLoadMore)
			this.setState({
				shouldLoadMore: false
			});

		if(shouldLoad && !this.state.shouldLoadMore)
			this.setState({
				shouldLoadMore: true
			});
	}

	openSearch = () => {
		const schema = this.props.schema || {};
		this.context.listen("customoptions:updated", this.handleModelUpdate);
		this.context.listen("customoptions:should:load", this.handleShouldLoadMore);
		this.context.listen("customoptions:loaded", this.handleLoaded);

		if(schema.optionType === "search")
			this.context.dispatch("customoptions:trigger:start", {
				fields: schema.fields,
				external: schema.external
			})();

		this.setState({
			searching: true
		});
	}

	openAdd = () => {
		this.setState({
			isAdd: true,
			searching: true,
		});
	}

	handleLoaded = () => {
		this.context.unlisten("customoptions:loaded", this.handleLoaded);
		this.setState({
			loaded: true
		});
	}

	hideSearch = () => {
		this.context.unlisten("customoptions:updated", this.handleModelUpdate);
		this.context.unlisten("customoptions:should:load", this.handleShouldLoadMore);
		this.setState({
			searching: false
		});
	}

	selectOption = (data) => {
		this.props.onChange(data);
		this.setState({
			searching: false,
			selected: data
		});
	}

	onChange = (key) => (value) => {
		const data = this.state.addData;
		data[key] = value;
		this.setState({
			addData: data
		});
	}

	submitAdd = () => {
		const data = this.state.addData;
		const schema = this.props.schema || {};
		const external = schema.external;

		this.context.dispatch("customoptions:trigger:add", {
			newData: data,
			external: external
		})();
		this.setState({
			isAdd: false
		});
	}

	cancelAdd = () => {
		this.setState({
			isAdd: false
		});
	}

	openEdit =(option) => {
		this.setState({
			isEdit: true,
			editData: option,
		});
	}

	closeEdit = () => {
		this.setState({
			isEdit: false
		});
	}

	save = () => {
		const props = this.props;
		const schema = props.schema || {};
		const external = schema.external;
		const fields = schema.fields;
		const data = this.state.editData;

		this.context.dispatch("customoptions:trigger:edit", {
			newData: data
		})();
		this.setState({
			isEdit: false,
			searching: true,
		});
		this.context.dispatch("customoptions:trigger:search", {
			query: "",
			fields: fields,
			external: external
		})();
	}

	handleEdit = (key) => (value) => {
		const data = this.state.editData;
		data[key] = value;
		this.setState({
			editData: data
		});
	}

	onChangeText = (text) => {
		const props = this.props;
		const schema = props.schema || {};
		const external = schema.external;
		const fields = schema.fields;

		this.context.dispatch("customoptions:trigger:search", {
			query: text,
			fields: fields,
			external: external
		})();
	}

	render(){
		const props = this.props;
		const context = this.context;
		const localize = context.localize;
		const localizeFrom = context.localizeFrom;
		const schema = props.schema || {};
		const defaultValue = this.state.selected || props.defaultValue;
		const showCustomAddButton = props.showCustomAddButton;

		if(schema.type !== "object"){
			return (
				<InputContainer>
					<StyledText>{"Custom option must be type option"}</StyledText>
				</InputContainer>
			);
		}

		const optionType = schema.optionType;

		let content = null;
		let input = null;

		let optionDisplay = localize("customoptions.startsearch");
		let extraDisplayProps = {
			grey: true
		};

		const optionLocalization = schema.valueLocalization || schema.value_localization;

		if(defaultValue && Object.keys(defaultValue).length > 0){
			optionDisplay = concatData(defaultValue);
			if(optionLocalization)
				optionDisplay = localizeFrom(optionLocalization, ".", defaultValue);
			delete extraDisplayProps.grey;
		}

		let textStyle = null;
		if(Platform.OS === "web")
			textStyle = [{width: "100%"}];

		if(optionType === "dropdown"){
			//TODO
		} else if (optionType === "search"){
			input = (
				<TouchableOpacity onPress={this.openSearch} style={styles.input}>
					<StyledIcon name="search" style={styles.icon} emphasized />
					<View style={styles.textContainer}>
						<StyledText {...extraDisplayProps} style={textStyle}>{optionDisplay}</StyledText>
					</View>
				</TouchableOpacity>
			);

			if(this.state.searching)
				content =  (
					<Search
						onChangeText={debounce(this.onChangeText, 500)}
						active={this.state.searching}
						showAdd = {showCustomAddButton}
						addOption={this.openAdd}
						goBack={this.hideSearch}
						showEdit={showCustomAddButton}
						options={this.state.options}
						defaultValue={defaultValue}
						selectOption={this.selectOption}
						shouldLoadMore={this.state.shouldLoadMore}
						optionLocalization={optionLocalization}
						loaded={this.state.loaded}
						openEdit={this.openEdit}
						searchText={this.state.searchText}
						loadMore={this.context.dispatch("customoptions:trigger:more")} />
				);
			if( this.state.isAdd)
				content = (
					<AddOption
						fields={schema.fields}
						active={this.state.isAdd}
						external={schema.external}
						submitAdd={this.submitAdd}
						cancel={this.cancelAdd}
						goBack={this.hideSearch}
						onChange={this.onChange}
						inputFields={this.state.keys}
						schema={schema}
						values={this.state.addData} />
				);

				if(this.state.isEdit)
				content = (
					<Edit
						active={this.state.isEdit}
						options={this.state.options}
						defaultValue={defaultValue}
						selectOption={this.selectOption}
						closeEdit={this.closeEdit}
						save={this.save}
						handleEdit={this.handleEdit}
						editData={this.state.editData}
						newData={this.state.newData}
						schema={schema}
					    />
				);
		}

		return (
			<InputContainer inline={props.inline}>
				<InputLabel schema={schema} />
				<ErrorMessage id={context.id_prefix + props.id + "_error"} errors={props.errors} schema={schema} />
				{input}
				{content}
			</InputContainer>
		);
	}
}

function AddOption(props){
	const containerStyle = [styles.primaryColor, {
		height: Dimensions.get("window").height
	}];
	const values = props.values || {};
	const schema = props.schema || {};
	const inputs = Object.keys(schema.properties).map((property) => {
		return (
			<View key={property} style={styles.form}>
			<View style={styles.label}>
				<StyledText >{getLocalizationValue(schema.properties[property])}: </StyledText>
			</View>
				<View key={property} style={styles.textContainer}>
					<TextInput
						onChangeText={props.onChange(property)}
						text={values[property]}
						style={styles.optionInput}
					/>
				</View>
			</View>
		);
	});

	return(
		<ModalOverlay isVisible={props.active} coverScreen={true}>
			<AESafeArea>
				<KeyboardAwareScrollView>
					<View style={containerStyle}>
						<MainScroll style={styles.scroll}>
							<View style={styles.container}>
								<Heading title={"Add new option"} />
								<View>
									{inputs}
								</View>
								<View style={styles.actions}>
									<View>
										<StyledButton onPress={props.submitAdd} title={"Add"} />
									</View>
									<View style={styles.cancel}>
										<StyledButton onPress={props.cancel} title={"Cancel"} />
									</View>
								</View>
							</View>
						</MainScroll>
					</View>
				</KeyboardAwareScrollView>
			</AESafeArea>
		</ModalOverlay>
		);
};


function Search(props, context){
	const localize = context.localize;
	const localizeFrom = context.localizeFrom;
	const onChangeText = props.onChangeText;
	const goBack = props.goBack;
	const active = props.active;
	const addOption	= props.addOption;
	const showAdd = props.showAdd;
	const openEdit = props.openEdit;
	const selectOption = props.selectOption;
	const shouldLoadMore = props.shouldLoadMore;
	const loadMore = props.loadMore;
	const optionLocalization = props.optionLocalization;
	const hasLoaded = props.loaded;
	const searchText = props.searchText;
	const showEdit = props.showEdit;

	const options = props.options;
	const defaultValue = props.defaultValue || {};

	let renderOptions = options.map(option => {
		const data = option.data;
		const select = () => {
			selectOption({
				_id: option._id,
				...data
			});
		};

		const selectEdit = () => {
			openEdit({
				_id: option._id,
				...data
			});
		};

		const isSelected = option._id === defaultValue._id;
		const selectTitle = isSelected ? localize("customoptions.selected") : localize("customoptions.select");

		let optionDisplay = concatData(data);
		if(optionLocalization)
			optionDisplay = localizeFrom(optionLocalization, ".", data);

		let textStyle = null;
		if(Platform.OS === "web")
			textStyle = [{width: "100%"}];

		return (
			<ListItem key={option._id} style={styles.listItem}>
				<View style={styles.textContainer}>
					<StyledText style={textStyle}>{optionDisplay}</StyledText>
				</View>
				<View style={styles.actions}>
					<StyledButton title={selectTitle} onPress={select} disabled={option._id === defaultValue._id} />
					{showEdit ? (
						<StyledButton title={"Edit"} onPress={selectEdit} style={styles.cancel}/>
					) : null}
				</View>
			</ListItem>
		);
	});

	if(!options.length && hasLoaded)
		renderOptions = (
			<View style={styles.noResultContainer}>
				<StyledText emphasized>{localize("customoptions.noresults")}</StyledText>
			</View>
		);

	const containerStyle = [styles.primaryColor, {
		height: Dimensions.get("window").height
	}];

	return (
		<ModalOverlay isVisible={active} coverScreen={true}>
			<AESafeArea>
				<View style={containerStyle}>
					<MainScroll style={styles.scroll}>
						<View style={styles.back}>
							<BackButton title={localize("customoptions.goback")} onPress={goBack} />
						</View>
						<View style={styles.container}>
							<View style={styles.header}>
									<Heading title={localize("customoptions.search")} />
									<View>
									{showAdd ? (
										<StyledButton title={localize("customoptions.addOption")} onPress={addOption} />
									) : null}
									</View>
								</View>
							<View style={styles.searchBox}>
								<SearchBox onChange={onChangeText} defaultValue={searchText}/>
								{renderOptions}
								{shouldLoadMore ? (
									<View style={styles.loadContainer}>
										<StyledButton title={localize("customoptions.loadMore")} onPress={loadMore} />
									</View>) : null}
							</View>
						</View>
					</MainScroll>
				</View>
			</AESafeArea>
		</ModalOverlay>
	);
}

function getLocalizationValue(item) {
	const schemaLocalization = item.localization || {};
	const keys = Object.keys(schemaLocalization);
	return schemaLocalization[keys[0]] ;
}

function Edit(props){
	const active = props.active;
	const containerStyle = [styles.primaryColor, {
		height: Dimensions.get("window").height
	}];
	const values = props.editData;
	const schema = props.schema || {};

	const renderEditOption = Object.keys(schema.properties).map((property) => {
		return(
			<View key={property} style={styles.form}>
				<View style={styles.label}>
					<StyledText>{getLocalizationValue(schema.properties[property])}: </StyledText>
				</View>
				<View style={styles.textContainer}>
					<TextInput
						onChangeText={props.handleEdit(property)}
						value={values[property]}
						style={styles.optionInput}
					/>
				</View>
			</View>
		);
	});

	return(
		<ModalOverlay isVisible={active} coverScreen={true}>
			<AESafeArea>
				<KeyboardAwareScrollView>
					<View style={containerStyle}>
						<MainScroll style={styles.scroll}>
							<View style={styles.back}>
								<BackButton title={"Go back"} onPress={props.closeEdit} />
							</View>
							<View style={styles.container}>
								<Heading title={"Edit option"} />
								<View >
									{renderEditOption}
								</View>
								<View style={styles.actions}>
									<View>
										<StyledButton title={"Save"} onPress={props.save} />
									</View>
									<View style={styles.cancel}>
										<StyledButton title={"Cancel"} onPress={props.closeEdit} />
									</View>
								</View>
							</View>
						</MainScroll>
					</View>
				</KeyboardAwareScrollView>
			</AESafeArea>
		</ModalOverlay>
	);
}

const AESafeArea = (props) => {
	if (Platform.OS === "ios") {
		return (<SafeAreaView style={styles.safeContainer}>
			{props.children}
		</SafeAreaView>);
	}
	else return props.children;
};

function concatData(data){
	return Object.keys(data).reduce((result, key) => {
		if(key === "_id") return result;
		return result.concat(data[key]);
	}, []).join(" ");
}

Search.contextTypes = {
	localize: PropTypes.func,
	localizeFrom: PropTypes.func
};

CustomOption.contextTypes = {
	localize: PropTypes.func,
	localizeFrom: PropTypes.func,
	dispatch: PropTypes.func,
	listen: PropTypes.func,
	unlisten: PropTypes.func
};